import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Application, StoreItem } from "../../types/types";

let initialState: StoreItem<Application[]> = {
  requestStatus: "not_initiated",
  responseStatus: "not_recieved",
  haveAnIssue: false,
  issue: "",
  data: []
};

export const ApplicationsSlice = createSlice({
  name: 'Applications',
  initialState: initialState,
  reducers: {
    initApplications: (state, action: PayloadAction<StoreItem<Application[]>>) => ({ ...action.payload }),
    addApplications: (state, action: PayloadAction<Application>) => { state.data.push(action.payload) },
    updateApplications: (state, action: PayloadAction<Application>) => {
      let index = state.data.findIndex((item) => item._id === action.payload._id);
      if (index !== -1) {
        state.data[index] = { ...state.data[index], ...action.payload };
      }
    },
    removeApplications: (state, action: PayloadAction<string>) => { state.data = state.data.filter((item) => item._id !== action.payload) },
    resetApplications: (state, action: PayloadAction) => ({ ...initialState })
  }
})

export const { initApplications, addApplications, removeApplications, updateApplications, resetApplications } = ApplicationsSlice.actions;
export default ApplicationsSlice.reducer;
